import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'
import { font, weightBold } from 'src/components/css'

/**
 * Shared section chrome for the spare-candidate detail modal, so every section
 * (Available Days, Player Bio, Penalty Minutes, Career Stats, Statistics) uses
 * one definition instead of four near-copies that drift apart.
 */

export const detailSectionStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

/** Uppercase section heading. */
export const detailSectionTitleStyle = css`
  ${font.body}
  ${weightBold}
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${colors.NEUTRAL_50};
`

/**
 * Recessed panel for a section's content (bio text, penalty chart, stat
 * tables). Darker than the modal body (SECONDARY_300) so the content reads as
 * inset rather than floating on the same flat surface.
 */
export const detailSectionPanelStyle = css`
  border: 1px solid ${colors.SOFT_STEEL};
  border-radius: 8px;
  background-color: ${colors.SECONDARY_400};
`
